module.exports = __webpack_public_path__ + "img/T-coin-grey.1950a98.png";